"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoicesAndPaymentsPagePlain = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var queryString = require("query-string");
var core_1 = require("@athena-portal/core");
var Types_1 = require("../../Types");
var InvoicesTable_1 = require("./InvoicesTable");
var PaymentsTable_1 = require("./PaymentsTable");
var components_1 = require("@athena-portal/components");
var SupportPortalTemplates_1 = require("../../SupportPortalTemplates");
var PaymentsHeader_1 = require("./PaymentsHeader");
var operators_1 = require("rxjs/operators");
var services_1 = require("@falcon/services");
var InvoicesAndPaymentsPagePlain = /** @class */ (function (_super) {
    __extends(InvoicesAndPaymentsPagePlain, _super);
    function InvoicesAndPaymentsPagePlain(props) {
        var _this = _super.call(this, props) || this;
        _this.templates = new SupportPortalTemplates_1.SupportPortalTemplates();
        _this.getInvoiceAndPaymentData = function () {
            _this.incrementLoadingQueueSize(function () {
                _this.supportPortalService
                    .getFalconInvoices(_this.props.params.id)
                    .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                    .subscribe(function (invoices) {
                    _this.setState({ invoices: invoices });
                });
            });
            _this.incrementLoadingQueueSize(function () {
                _this.supportPortalService
                    .getPayments(_this.props.params.id)
                    .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                    .subscribe(function (payments) {
                    _this.setState({ payments: payments });
                });
            });
        };
        _this.setUpdatedInvoiceId = function (invoiceId) {
            _this.setState({
                updatedInvoiceId: invoiceId
            });
        };
        _this.incrementLoadingQueueSize = function (callback) {
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize + 1
            }); }, callback);
        };
        _this.decrementLoadingQueueSize = function (callback) {
            if (_this.state.loadingQueueSize === 0) {
                return;
            }
            _this.setState(function (prevState) { return ({
                loadingQueueSize: prevState.loadingQueueSize - 1
            }); }, callback);
        };
        _this.loading = function () {
            return _this.state.loadingQueueSize !== 0;
        };
        _this.state = {
            loadingQueueSize: 0
        };
        return _this;
    }
    InvoicesAndPaymentsPagePlain.prototype.componentDidMount = function () {
        var _this = this;
        this.incrementLoadingQueueSize(function () {
            _this.setState({ policyNumber: queryString.parse(_this.props.location.search).policy });
            _this.decrementLoadingQueueSize();
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getPolicies(_this.props.params.id)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (policies) {
                _this.setState({ policies: policies });
                var policy = policies.find(function (p) { return p.number.includes(_this.state.policyNumber); });
                if (policy && policy.products[0]) {
                    _this.setState({ policyProduct: policy.products[0] });
                }
            });
        });
        this.incrementLoadingQueueSize(function () {
            _this.supportPortalService
                .getParty(_this.props.params.id)
                .pipe((0, operators_1.finalize)(_this.decrementLoadingQueueSize))
                .subscribe(function (party) {
                _this.setState({ party: party });
            });
        });
        this.getInvoiceAndPaymentData();
    };
    InvoicesAndPaymentsPagePlain.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var firstName = (_a = this.state.party) === null || _a === void 0 ? void 0 : _a.firstName;
        var lastname = (_b = this.state.party) === null || _b === void 0 ? void 0 : _b.lastName;
        var isAnnualPolicy = this.state.policyProduct === services_1.ProductsEnum.WOLF_MOTOR || this.state.policyProduct === services_1.ProductsEnum.HOME;
        document.title = "".concat(firstName, " ").concat(lastname, " invoices and payments");
        var annualPolicy;
        if (this.state.policyNumber && isAnnualPolicy) {
            annualPolicy = this.state.policies ? this.state.policies.filter(function (p) { return p.number.includes(_this.state.policyNumber); })[0] : null;
        }
        var lastVersion = annualPolicy ? annualPolicy.versions.length - 1 : null;
        var annualPolicyVersionNumber = annualPolicy && lastVersion !== null ? annualPolicy.versions[lastVersion].policyVersionNumber : null;
        var filteredInvoices = this.getInvoicesByProduct();
        var invoiceNumbers = filteredInvoices ? this.getInvoiceNumbers(filteredInvoices === null || filteredInvoices === void 0 ? void 0 : filteredInvoices.results) : [];
        var filteredPayments = this.getPaymentsByInvoices(invoiceNumbers);
        if (this.templates.userHasRole(["Administrator", "Claims_Handler", "Fraud", "CSR_Lead", "CSR", "Support", "Read_Only"])) {
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.loading() }), this.templates.renderHeader(), this.templates.renderBackLink("Customer page", true, "/customers/".concat(this.props.params.id)), isAnnualPolicy && annualPolicyVersionNumber && this.state.party &&
                        (0, jsx_runtime_1.jsx)(PaymentsHeader_1.default, { userId: this.props.params.id, party: this.state.party, policyNumber: annualPolicy.number, version: annualPolicyVersionNumber, firstName: firstName, lastName: lastname }), (0, jsx_runtime_1.jsx)(PaymentsTable_1.default, { payments: filteredPayments, customerReferenceNumber: this.props.params.id, loading: this.loading() }), (0, jsx_runtime_1.jsx)(InvoicesTable_1.default, { invoices: filteredInvoices, payments: this.state.payments, loading: this.loading(), customerReferenceNumber: this.props.params.id, getInvoiceAndPaymentData: this.getInvoiceAndPaymentData, setUpdatedInvoiceId: this.setUpdatedInvoiceId, updatedInvoiceId: this.state.updatedInvoiceId })] }));
        }
        else {
            return this.templates.renderErrorPage();
        }
    };
    InvoicesAndPaymentsPagePlain.prototype.getPaymentsByInvoices = function (invoices) {
        var filteredPayments = {
            count: 0,
            results: []
        };
        var paymentResults = [];
        if (this.state.payments && this.state.payments.count > 0) {
            paymentResults = this.state.payments.results.filter(function (p) { return invoices.includes(p.invoiceId.toString()); });
            filteredPayments.results = paymentResults;
            filteredPayments.count = paymentResults.length;
        }
        return filteredPayments;
    };
    InvoicesAndPaymentsPagePlain.prototype.getInvoiceNumbers = function (invoices) {
        return invoices.map(function (inv) { return inv.id; });
    };
    InvoicesAndPaymentsPagePlain.prototype.getInvoicesByProduct = function () {
        var _this = this;
        var isAnnualPolicy = this.state.policyProduct === services_1.ProductsEnum.WOLF_MOTOR || this.state.policyProduct === services_1.ProductsEnum.HOME;
        var _a = this.state, invoices = _a.invoices, policies = _a.policies;
        var invoicesResults = [];
        var filteredInvoices = {
            count: 0,
            results: []
        };
        if (invoices && invoices.count > 0 && policies && policies.length > 0) {
            if (isAnnualPolicy) {
                invoicesResults = invoices.results.filter(function (i) { return i.policies.includes(_this.state.policyNumber); });
            }
            else {
                var filteredPolicies = policies.filter(function (p) { return p.products.includes(services_1.ProductsEnum.MOTOR) || p.products.includes(services_1.ProductsEnum.RENTERS); });
                var policyNumbers = filteredPolicies.map(function (p) { return p.number; });
                policyNumbers.forEach(function (policyNumber) {
                    var results = invoices.results.filter(function (i) { return i.policies.includes(policyNumber); });
                    invoicesResults = invoicesResults.concat(results);
                });
            }
            filteredInvoices.results = invoicesResults;
            filteredInvoices.count = invoicesResults.length;
        }
        return filteredInvoices;
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.SupportPortalService),
        __metadata("design:type", Object)
    ], InvoicesAndPaymentsPagePlain.prototype, "supportPortalService", void 0);
    InvoicesAndPaymentsPagePlain = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], InvoicesAndPaymentsPagePlain);
    return InvoicesAndPaymentsPagePlain;
}(React.Component));
exports.InvoicesAndPaymentsPagePlain = InvoicesAndPaymentsPagePlain;
exports.default = (0, components_1.withRouter)(InvoicesAndPaymentsPagePlain);
//# sourceMappingURL=InvoicesAndPaymentsPage.js.map